var m = require('mithril');
var formGroup = require('../formGroup');

var component = {};

function getNameFromValue(value) {
  if (!value) return '';
  if (typeof value === 'string') {
    return value.split('\\').pop().split('/').pop();
  }
  if (value && value.name) {
    return value.name;
  }
  return '';
}

function clearInputIfNoFileName(inputVnode, currentFileName) {
  if (!currentFileName && inputVnode && inputVnode.dom && inputVnode.dom.value) {
    inputVnode.dom.value = '';
  }
}

component.oninit = function oninit(vnode) {
  var value = (typeof vnode.attrs.prop === 'function') ? vnode.attrs.prop() : null;
  vnode.state.fileName = getNameFromValue(value);
};

component.onbeforeupdate = function onbeforeupdate(vnode) {
  if (typeof vnode.attrs.prop === 'function') {
    vnode.state.fileName = getNameFromValue(vnode.attrs.prop());
  }
  return true;
};

component.view = function view (vnode) {
  var field = vnode.attrs.field || {};
  var handleChange = vnode.attrs.onChange || vnode.attrs.prop;
  var currentFileName = vnode.state.fileName || '';

  return m(formGroup, [
    m('label', field.name),
    m('br'),
    m('label.dib.ba.b--white.pa2.pointer', {
      for: (field.id || 'file') + '-input'
    }, 'Upload File', [
      m('i.ion-ios-cloud-upload.white.ml1')
    ]),
    m('label.dib.pa2.', currentFileName),
    m('input.form-control', {
      id: (field.id || 'file') + '-input',
      type: 'file',
      name: field.name,
      accept: field.accept || vnode.attrs.accept,
      oncreate: function (inputVnode) {
        clearInputIfNoFileName(inputVnode, vnode.state.fileName);
      },
      onupdate: function (inputVnode) {
        clearInputIfNoFileName(inputVnode, vnode.state.fileName);
      },
      onchange: function (e) {
        var files = e.target.files || [];
        var selectedFile = files[0] || null;
        vnode.state.fileName = getNameFromValue(selectedFile) || (this.value || '').split('\\').pop();
        if (typeof handleChange === 'function') {
          handleChange(selectedFile);
        }
      },
      style: {
        display: 'none'
      }
    })
  ]);
};

module.exports = component;
